import { AxiosInstance } from "axios";
import {
  CURRENT_ACCOUNTKEY,
  FINAL_SELECTED_ACCOUNT,
  PRE_SELECTED_ACCOUNT,
  PRE_SELECTED_CONTACTS,
} from "constant";

export const createSuccessPlanAPI = (axios: AxiosInstance) => {
  return {
    getSuccessPlan: async (accountId: string): Promise<any> => {
      const resp = await axios.get(`/api/dataservice/v1/success-plans?accountId=${accountId}`);
      return resp.data;
    },
    patchSuccessPlan: async (planId: string, payload: any): Promise<any> => {
      const resp = await axios.patch(`/api/dataservice/v1/success-plans/${planId}`, payload);

      sessionStorage.removeItem(PRE_SELECTED_ACCOUNT);
      sessionStorage.removeItem(PRE_SELECTED_CONTACTS);
      sessionStorage.removeItem(FINAL_SELECTED_ACCOUNT);
      sessionStorage.removeItem(CURRENT_ACCOUNTKEY);
      return resp.data;
    },
    createSuccessPlan: async (payload: any): Promise<string> => {
      const { data: epId } = await axios.post<string>(`/api/dataservice/v1/success-plans`, payload);
      sessionStorage.removeItem(PRE_SELECTED_ACCOUNT);
      sessionStorage.removeItem(PRE_SELECTED_CONTACTS);
      sessionStorage.removeItem(FINAL_SELECTED_ACCOUNT);
      sessionStorage.removeItem(CURRENT_ACCOUNTKEY);
      return epId;
    },
  };
};
